/**
 * Static reference data for vehicle forms.
 * Brazilian-market focused. Datalist-friendly so users can type or pick.
 */

export const VEHICLE_BRANDS = [
  "Audi", "BMW", "BYD", "Caoa Chery", "Chevrolet", "Citroën", "Dodge", "Fiat",
  "Ford", "GWM", "Honda", "Hyundai", "Iveco", "Jaguar", "Jeep", "Kia",
  "Land Rover", "Lexus", "Mercedes-Benz", "Mini", "Mitsubishi", "Nissan",
  "Peugeot", "Porsche", "Ram", "Renault", "Subaru", "Suzuki", "Toyota",
  "Volkswagen", "Volvo",
];

/** Most popular models per brand in Brazil (concise — users can also type freely). */
export const VEHICLE_MODELS_BY_BRAND = {
  "Audi": ["A3", "A4", "A5", "Q3", "Q5", "Q7", "Q8", "RS3", "RS5"],
  "BMW": ["118i", "320i", "330i", "M3", "M4", "X1", "X3", "X5", "X6", "Z4"],
  "BYD": ["Dolphin", "Han", "Seal", "Song Plus", "Tan", "Yuan Plus"],
  "Caoa Chery": ["Arrizo 5", "Arrizo 6", "Tiggo 2", "Tiggo 3X", "Tiggo 5X", "Tiggo 7", "Tiggo 8"],
  "Chevrolet": ["Cobalt", "Cruze", "Equinox", "Montana", "Onix", "Onix Plus", "Prisma", "S10", "Spin", "Tracker", "Trailblazer"],
  "Citroën": ["Aircross", "C3", "C4 Cactus", "C4 Lounge"],
  "Dodge": ["Charger", "Journey", "Ram 1500"],
  "Fiat": ["Argo", "Cronos", "Fastback", "Fiorino", "Mobi", "Pulse", "Strada", "Toro", "Uno"],
  "Ford": ["Bronco", "EcoSport", "Edge", "Fiesta", "Focus", "Fusion", "Ka", "Maverick", "Ranger", "Territory"],
  "GWM": ["Haval H6", "Ora 03"],
  "Honda": ["City", "Civic", "CR-V", "Fit", "HR-V", "WR-V", "ZR-V"],
  "Hyundai": ["Creta", "Elantra", "HB20", "HB20S", "Santa Fe", "Tucson"],
  "Iveco": ["Daily"],
  "Jaguar": ["E-Pace", "F-Pace", "XE", "XF"],
  "Jeep": ["Commander", "Compass", "Gladiator", "Grand Cherokee", "Renegade", "Wrangler"],
  "Kia": ["Cerato", "Picanto", "Sorento", "Soul", "Sportage", "Stonic"],
  "Land Rover": ["Defender", "Discovery", "Discovery Sport", "Range Rover", "Range Rover Evoque", "Range Rover Sport", "Range Rover Velar"],
  "Lexus": ["ES", "IS", "NX", "RX", "UX"],
  "Mercedes-Benz": ["A 200", "C 180", "C 200", "C 300", "CLA 200", "E 250", "GLA 200", "GLB 200", "GLC 300", "GLE 350"],
  "Mini": ["Cooper", "Cooper S", "Countryman"],
  "Mitsubishi": ["ASX", "Eclipse Cross", "L200 Triton", "Outlander", "Pajero"],
  "Nissan": ["Frontier", "Kicks", "Sentra", "Versa"],
  "Peugeot": ["208", "2008", "3008", "5008", "Partner"],
  "Porsche": ["718 Cayman", "911", "Cayenne", "Macan", "Panamera", "Taycan"],
  "Ram": ["1500", "2500", "3500", "Rampage"],
  "Renault": ["Captur", "Duster", "Kardian", "Kwid", "Logan", "Oroch", "Sandero", "Stepway"],
  "Subaru": ["Forester", "Outback", "WRX"],
  "Suzuki": ["Jimny", "S-Cross", "Vitara"],
  "Toyota": ["Camry", "Corolla", "Corolla Cross", "Etios", "Hilux", "RAV4", "SW4", "Yaris"],
  "Volkswagen": ["Amarok", "Fox", "Gol", "Jetta", "Nivus", "Polo", "Saveiro", "T-Cross", "Taos", "Tiguan", "Up", "Virtus", "Voyage"],
  "Volvo": ["XC40", "XC60", "XC90"],
};

/** Common Brazilian car colors — datalist suggestions, free typing also allowed. */
export const VEHICLE_COLORS = [
  "Branco", "Prata", "Preto", "Cinza", "Grafite", "Vermelho", "Azul",
  "Azul Escuro", "Bege", "Marrom", "Verde", "Verde Escuro", "Amarelo",
  "Laranja", "Bordô", "Champanhe", "Dourado",
];

/** Year range — current year + 1 down to 1990 (newest first). */
export function buildVehicleYears() {
  const current = new Date().getFullYear();
  const years = [];
  for (let y = current + 1; y >= 1990; y--) years.push(String(y));
  return years;
}
